export default __webpack_public_path__ + "static/media/cover-image.0f37c86b.jpg";